module.exports = __webpack_public_path__ + "img/hometitle.12f55ba6.png";